import { useRef, useCallback, useEffect } from "react"
import useSettings from "../../hooks/settings.hook"
import dashbordStore from '../../store/dashbord'

const TdCell = ({
  height = 'h-[6rem]',
  useSort = true,
  name,
  sort: { path, correction } = {},
  currentStage,
  children,
  initialWidth,
  available = true,
  onClick,
  width,
  title,
  checkbox,
  sortPath,
  dimensional = true,
  onColResize,
  ...props
}) => {
  const { updateSettings } = useSettings()
  const colSizer = useRef()
  const state = useRef({})

  const onMouseDownHandler = useCallback(
    ev => {
      state.current.isActive = true
      state.current.clientX = ev.clientX
    },
    [state]
  )

  const onMouseUpHandler = useCallback(async () => {
    if (state.current.isActive) {
      dashbordStore.updateInitialColumnWidth(name)
      updateSettings()
    }
    state.current.isActive = false
  }, [state, name])

  const onMouseMoveHandler = useCallback(
    ev => {
      if (state.current.isActive) {
        let newWidth = initialWidth + (ev.clientX - state.current.clientX) / 10
        if (newWidth < 5) newWidth = 5
        onColResize(name, newWidth)
      }
    },
    [state, initialWidth]
  )

  useEffect(() => {
    colSizer.current?.addEventListener('mousedown', onMouseDownHandler)
    document.addEventListener('mouseup', onMouseUpHandler)
    document.addEventListener('mousemove', onMouseMoveHandler)
    return () => {
      colSizer.current?.removeEventListener('mousedown', onMouseDownHandler)
      document.removeEventListener('mouseup', onMouseUpHandler)
      document.removeEventListener('mousemove', onMouseMoveHandler)
    }
  }, [colSizer, state, initialWidth, available])

  let direction

  if (path === sortPath) {
    direction = correction
  }

  if (!available || ((currentStage?.service || !currentStage?.id) && props.hideOnService)) return null
  return (
    <th
      style={{
        width: (width || 5) + 'rem'
      }}
      className={`
              ${height}
              ${props.className}
              ${checkbox ? 'flex-0' : 'flex-0'}
              p-[1.2rem] flex items-center  overflow-hidden
              ${dimensional && 'relative'}
          `}>
      {children}
      <div
        onClick={() =>
          sortPath &&
          useSort &&
          dashbordStore.setSort({
            path: sortPath,
            name: title,
            correction: correction === 'asc' ? 'desc' : 'asc'
          })
        }
        className='flex  gap-[0.6rem] items-center hover:cursor-pointer group'>
        <span className='text-Regular(12_14) text-Content/Dark font-semibold'>{title}</span>
        {props.configurable && sortPath && useSort && (
          <span
            className={`
                          ${
                            direction === 'asc'
                              ? 'text-Content/Dark'
                              : direction === 'desc'
                                ? 'text-Content/Dark rotate-180'
                                : 'text-Content/Light'
                          }
                          group-hover:text-Accent/Blue
                          `}>
            <i className={`icon-sort text-[1.6rem] flex-auto`}></i>
          </span>
        )}
        {!checkbox && dimensional && (
          <span
            ref={colSizer}
            onClick={ev => ev.stopPropagation()}
            className='
                              after:absolute
                              after:top-0
                              after:bottom-0
                              after:w-[10px]
                              after:left-0
                              after:translate-x-[-50%]
                              hover:cursor-col-resize
                              w-[1px] h-[50%] top-[50%] translate-y-[-50%] absolute right-0  bg-Content/Border'></span>
        )}
      </div>
    </th>
  )
}

export default TdCell
